import React, { Component } from 'react';
import TextCropper from '@omilia/text-cropper';
import Icon from '@omilia/icon';
import { colors } from '@omilia/theme';
import cn from 'classnames';

import { contextType } from 'types';

import './style.scss';

export default class ContextItem extends Component {
  static propTypes = {
    model: contextType,
  };

  shouldComponentUpdate(nextProps) {
    const {
      model: { name },
    } = this.props;

    return nextProps.model.name !== name;
  }

  render() {
    const { model } = this.props;

    return (
      <div
        styleName={cn('context-item', {
          'is-archived': model.archived,
        })}
      >
        <div styleName="name">
          <TextCropper styleName="cropper" text={model.name} />
        </div>
        {model.archived && (
          <Icon
            glyph="archived"
            primaryColor={colors.COLOR_ORANGE_400}
            size="16"
          />
        )}
      </div>
    );
  }
}
